import { rest } from 'utils';

export default {
  create: ({ dcId, properties }) => rest.post({ url: `datacenters/${dcId}/natgateways`, body: { properties } }),
  getAll: ({ dcId }) => rest.get({ url: `datacenters/${dcId}/natgateways` }),
  get: ({ dcId, id }) => rest.get({ url: `datacenters/${dcId}/natgateways/${id}?depth=4` }),
  update: ({ dcId, id, properties }) => rest.put({ url: `datacenters/${dcId}/natgateways/${id}?depth=4`, body: { properties } }),
  delete: ({ dcId, id }) => rest.delete({ url: `datacenters/${dcId}/natgateways/${id}` }),
  createRule: ({ dcId, id, properties }) => rest.post({ url: `datacenters/${dcId}/natgateways/${id}/rules`, body: { properties } }),
  updateRule: ({
    dcId, id, ruleId, properties,
  }) => rest.put({ url: `datacenters/${dcId}/natgateways/${id}/rules/${ruleId}`, body: { properties } }),
  deleteRule: ({ dcId, id, ruleId }) => rest.delete({ url: `datacenters/${dcId}/natgateways/${id}/rules/${ruleId}` }),
};
